/*
  ALPOVERA · Fast Bundle helper
  Adds a "Tanesi 287.50TL" unit-price line under each volume option. It divides the
  option's final price (already shown by the app) by the pair count in its title,
  so it never invents a number. Re-runs when the app re-renders.
*/
(() => {
  const LABEL = (window.AlpoveraConfig && window.AlpoveraConfig.strings && window.AlpoveraConfig.strings.unit) || 'Tanesi';

  // "1,898.00TL" / "1.898,00 TL" / "₺1.898" -> { value, format }
  function parsePrice(text) {
    const raw = (text || '').trim();
    const m = raw.match(/[\d.,]+/);
    if (!m) return null;
    let num = m[0];
    const lastComma = num.lastIndexOf(',');
    const lastDot = num.lastIndexOf('.');
    let decimal = '.';
    if (lastComma > lastDot && num.length - lastComma - 1 === 2) decimal = ',';
    const group = decimal === '.' ? ',' : '.';
    const value = parseFloat(num.split(group).join('').replace(decimal, '.'));
    if (!isFinite(value)) return null;
    return { value, prefix: raw.slice(0, m.index), suffix: raw.slice(m.index + m[0].length), decimal, group };
  }

  function formatLike(value, p) {
    const fixed = value.toFixed(2);
    let [int, dec] = fixed.split('.');
    int = int.replace(/\B(?=(\d{3})+(?!\d))/g, p.group);
    return p.prefix + int + p.decimal + dec + p.suffix;
  }

  function update(root) {
    root.querySelectorAll('[data-rbrselector="discountInfoV3"]').forEach((row) => {
      const desc = row.querySelector('[data-rbrselector="discountInfoV3Description"]');
      const price = row.querySelector('[data-rbrselector="discountInfoV3FinalPrice"]');
      if (!desc || !price) return;
      const title = desc.querySelector(':scope > span');
      const qty = title ? parseInt((title.textContent.match(/\d+/) || [])[0], 10) : NaN;
      const p = parsePrice(price.textContent);
      let line = desc.querySelector('.avfb-unit');
      if (!p || !qty || qty < 2) { if (line) line.remove(); return; }
      const text = LABEL + ' ' + formatLike(p.value / qty, p);
      if (!line) {
        line = document.createElement('span');
        line.className = 'avfb-unit';
        desc.appendChild(line);
      }
      if (line.textContent !== text) line.textContent = text;
    });
  }

  let queued = false;
  const schedule = () => {
    if (queued) return;
    queued = true;
    requestAnimationFrame(() => { queued = false; update(document); });
  };

  const start = () => {
    update(document);
    new MutationObserver((records) => {
      for (const r of records) {
        if (r.target.nodeType === 1 && r.target.closest && r.target.closest('.avfb-unit')) continue;
        if (r.target.parentElement && r.target.parentElement.closest && r.target.parentElement.closest('.avfb-unit')) continue;
        schedule();
        break;
      }
    }).observe(document.body, { childList: true, subtree: true, characterData: true });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
